<script setup lang="ts">
import {$inj, $injByInterface} from '@/common/decorators/depinject'
import InstitutionLabel from '@/common/components/bltSideNav/institutionLabel.vue'
import ConstantFactory from '@/common/services/utils/ConstantFactory'
import {computed, onMounted, ref, watch} from 'vue'
import type ActiveChannel from '@/common/interfaces/ActiveChannel.ts'

const constantFactory = $inj(ConstantFactory)
const showUatBanner = ref(false)

onMounted(() => {
  showUatBanner.value = constantFactory.getBool('SHOW_UAT_BANNER') ?? false
})

watch(showUatBanner, (newval) => {
  newval
    ? window.document.documentElement.classList.add('showUatBanner')
    : window.document.documentElement.classList.remove('showUatBanner')
})

const multitenancyEnabled = computed(() => window.MULTITENANCY_ENABLED)
const activeChannel = $injByInterface<ActiveChannel>('ActiveChannel')
const isOpen = computed(() => activeChannel.type === 'APPLICANT')
</script>

<template>
  <div
    id="UAT_BANNER"
    v-if="showUatBanner">
    UAT &nbsp; <InstitutionLabel v-if="multitenancyEnabled && !isOpen" />
  </div>
</template>

<style scoped>
#UAT_BANNER {
  text-align: center;
  line-height: 24px;
  background-color: var(--jha-text-theme);
  color: var(--primary-button-text-color);
  position: sticky;
  top: 0;
  left: 0;
  z-index: 5000;
}
</style>
